import React from 'react'
import DesignProjectCard from './DesignProjectCard.js'

export default class DesignProjects extends React.Component {
    render() {
        return <div className="designProjects">
            { this.props.designs.map(edge => <DesignProjectCard key={ edge.node.id } node={ edge.node }/>)}
        </div>
    }
}
